export default function useSubJob() {
  const list = ['Blank MAT', 'Lathe', 'Milling', 'Gringing', 'CNC', 'Wire cut', 'EDM', 'HRC/Sur.', 'Supper drill', 'Tap', 'Hold', 'Defective'];

  const subJobType = [
    // 'ME',
    'EE', 'STD', 'FAB', 'PNUE', 'OTHER',
  ];

  const qcStatusEN = ['QC_PROGRESS', 'PRODUCTION', 'SURFACE_TREATMENT', 'HEAT_TREATMENT', 'CLAIM', 'STORE', 'QC_PASS', 'NG'];
  const qcStatusTH = ['รับเข้า QC', 'ส่งต่อ Production', 'Surface Treatment', 'Heat Treatment', 'งานเคลม', 'ผ่าน QC (เข้า Store)', 'ผ่าน QC', 'NG'];
  const qcStatusAmountColumn = ['qc_progress_amount', 'qc_production_amount', 'qc_surface_amount', 'qc_heat_amount', 'qc_claim_amount', 'qc_store_amount', 'qc_pass_amount', 'qc_ng_amount'];

  const subJobStatus = [
    'PENDING', 'OUTSOURCE',
    'PR', 'WAITING_APPROVE_PR', 'PO', 'WAITING_APPROVE_PO',
    'STORE_RECEIVE', 'WITHDRAW',
    'STAND_BY', 'IN_PROGRESS',
    'QC', 'QC_PROGRESS', 'QC_PASS', 'NG',
    'MODIFY', 'REVISE',
    'READY_ASSEMBLY', 'ASSEMBLY', 'FAILED_ASSEMBLY', 'DONE',
    'CANCELLED',
  ];
  const subJobStatusTH = [
    'ตรวจสอบชิ้นส่วน', 'จ้างผลิต',
    'ขอซื้อ', 'รออนุมัติขอซื้อ', 'รอรับสินค้า', 'รออนุมัติใบสั่งซื้อ',
    'พร้อมเบิก', 'สร้างใบเบิกแล้ว',
    'พร้อมผลิต', 'กำลังผลิต',
    'รอเข้า QC', 'รับเข้า QC', 'ผ่าน QC', 'งาน NG',
    'Modify', 'Revise',
    'พร้อมประกอบ', 'กำลังประกอบ', 'ประกอบไม่สำเร็จ', 'เสร็จสิ้น',
    'ยกเลิก',
  ];

  const assemblyStatusTH = ['ยังไม่ถูกประกอบ', 'เบิกแล้ว', 'ระหว่างประกอบ', 'ประกอบเสร็จ', 'ประกอบล้มเหลว'];
  const assemblyStatusEN = ['PENDING', 'RECEIVE', 'IN_PROGRESS', 'DONE', 'FAILED'];
  const assemblyAmountColumn = ['assembly_pending_amount', 'assembly_receive_amount', 'assembly_progress_amount', 'assembly_done_amount', 'assembly_failed_amount'];

  function translateSubJobStatus(status: string) {
    const index = subJobStatus.indexOf(status);
    if (index > -1) return subJobStatusTH[index];
    return status;
  }

  function processTranslate(status: string, rawStatus: string) {
    if (rawStatus === 'DONE') return 'สำเร็จ';
    if (rawStatus === 'QC_PASS') return 'สำเร็จ';
    if (status === 'CANCELLED') return 'ยกเลิก';
    if (status === 'PENDING') return 'รอการผลิต';
    if (status === 'OUTSOURCE') return 'จ้างผลิต';
    return status;
  }

  function statusToQCAmountColumn(status: string) {
    const index = qcStatusEN.indexOf(status);
    if (index > -1) return qcStatusAmountColumn[index];
    return status;
  }
  function statusToAssemblyAmountColumn(status: string) {
    const index = assemblyStatusEN.indexOf(status);
    if (index > -1) return assemblyAmountColumn[index];
    return status;
  }

  function getProcessStatusColor(status: string) {
    let text = '';
    let bg = '';
    switch (status) {
      case 'Blank MAT':
        bg = 'orange-500'; text = 'white'; break;
      case 'Lathe':
        bg = 'yellow-500'; text = 'white'; break;
      case 'Milling':
        bg = 'pink-500'; text = 'white'; break;
      case 'Gringing':
        bg = 'purple-500'; text = 'white'; break;
      case 'CNC':
        bg = 'teal-400'; text = 'white'; break;
      case 'Wire cut':
        bg = 'blue-400'; text = 'white'; break;
      case 'EDM':
        bg = 'indigo-400'; text = 'white'; break;
      case 'HRC/Sur.':
        bg = 'pink-400'; text = 'white'; break;
      case 'CANCELLED':
        bg = 'gray-300'; text = 'black'; break;
      case 'DONE':
        bg = 'green-500'; text = 'white'; break;
      case 'OUTSOURCE':
        bg = 'gray-600'; text = 'white'; break;
      case 'Supper drill':
        bg = 'teal-500'; text = 'white'; break;
      case 'Tap':
        bg = 'blue-500'; text = 'white'; break;
      case 'Hold':
        bg = 'indigo-400'; text = 'white'; break;
      case 'Defective':
        bg = 'pink-500'; text = 'white'; break;
      case 'Cancel':
        bg = 'gray-300'; text = 'black'; break;
      case 'QC':
        bg = 'orange-600'; text = 'white'; break;
      case 'QC_PASS':
        bg = 'green-500'; text = 'white'; break;
      case 'NG':
        bg = 'pink-600'; text = 'white'; break;
      case 'PRODUCTION':
        bg = 'pink-600'; text = 'white'; break;
      case 'SURFACE_TREATMENT':
        bg = 'orange-600'; text = 'white'; break;
      case 'HEAT_TREATMENT':
        bg = 'blue-600'; text = 'white'; break;
      case 'CLAIM':
        bg = 'red-500'; text = 'white'; break;
      case 'STORE':
        bg = 'yellow-300'; text = 'black'; break;
      default:
        bg = 'indigo-600'; text = 'white'; break;
    }
    return { text, bg };
  }

  const statusClassMap = (status: string) => {
    switch (status) {
      case 'DONE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'PRODUCE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-600';
      case 'PENDING':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-600';
      case 'MODIFY':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-600';
      case 'ORDER':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'STOCK':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-secondary-500';
      case 'OUTSOURCE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-600';
      case 'CANCELLED':
        return 'block text-black rounded-xl text-xs py-1 text-center bg-gray-300';
      case 'PR':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-purple-600';
      case 'PO':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-300';
      case 'STORE_RECEIVE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-600';
      case 'WITHDRAW':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'STAND_BY':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-indigo-600';
      case 'IN_PROGRESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-secondary-600';
      case 'WAITING_APPROVE_PO':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-500';
      case 'WAITING_APPROVE_PR':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-400';
      case 'FAILED_ASSEMBLY':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-400';
      case 'QC':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-600';
      case 'QC_PROGRESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-600';
      case 'QC_PASS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'NG':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-pink-600';
      case 'PRODUCTION':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-600';
      case 'SURFACE_TREATMENT':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'HEAT_TREATMENT':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'CLAIM':
        return 'block text-black rounded-xl text-xs py-1 text-center bg-yellow-300';
      case 'STORE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-indigo-600';
      default: return processStatusClassMap(status);
    }
  };

  const processStatusClassMap = (status: string) => {
    // if (rawStatus === 'DONE') return statusClassMap('DONE');
    // if (rawStatus === 'QC_PASS') return statusClassMap('DONE');
    const { text, bg } = getProcessStatusColor(status);
    return `block rounded-xl text-xs text-center px-3 py-1 bg-${bg} text-${text}`;
  };

  function assemblyStatusClassMap(status: string) {
    switch (status) {
      case 'PENDING':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-600';
      case 'RECEIVE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-indigo-600';
      case 'DONE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'IN_PROGRESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-500';
      case 'FAILED':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-300';
      case 'CANCELLED':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-gray-600';
      default: return '';
    }
  }
  function translateAssemblyStatus(status: string) {
    const index = assemblyStatusEN.indexOf(status);
    if (index > -1) return assemblyStatusTH[index];
    return '-';
  }

  function qcStatusClassMap(status: string) {
    switch (status) {
      case 'QC':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-600';
      case 'QC_PROGRESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-yellow-600';
      case 'QC_PASS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'NG':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-pink-600';
      case 'PRODUCTION':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-600';
      case 'SURFACE_TREATMENT':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-blue-600';
      case 'HEAT_TREATMENT':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'CLAIM':
        return 'block text-black rounded-xl text-xs py-1 text-center bg-yellow-300';
      case 'STORE':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-indigo-600';
      default: return 'block text-black rounded-xl text-xs py-1 text-center bg-gray-400';
    }
  }
  function translateQCStatus(status: string) {
    const index = qcStatusEN.indexOf(status);
    if (index > -1) return qcStatusTH[index];
    return 'รอเข้า QC';
  }

  const subJobFilter = {
    'in-house': {
      filterExceptStatus: 'CANCELLED', filterExceptProcessStatus: 'OUTSOURCE', productionType: ['FAB'],
    },
    outsource: {
      filterProcessStatus: 'OUTSOURCE', filterExceptStatus: 'CANCELLED', productionType: ['FAB'],
    },
    pending: {
      hasPoItems: true, filterStatus: 'PENDING', filterExceptStatus: 'CANCELLED', filterExceptProcessStatus: 'OUTSOURCE', hasWithdrawItems: false,
    },
    'waiting-purchase': {
      hasPoItems: false, filterExceptStatus: 'CANCELLED', filterExceptProcessStatus: 'OUTSOURCE', excludeProductionType: ['FAB'],
    },
    qa: { filterProcessStatus: 'QC', filterExceptStatus: 'QC_PASS' },
  };

  const storeAmountColumn = ['store_amount'];

  function sumSubJobStatusAmount(bomItem: any) {
    let total = 0;
    for (let i = 0; i < qcStatusAmountColumn.length; i += 1) {
      total += bomItem[qcStatusAmountColumn[i]];
    }
    for (let i = 0; i < assemblyAmountColumn.length; i += 1) {
      total += bomItem[assemblyAmountColumn[i]];
    }
    for (let i = 0; i < storeAmountColumn.length; i += 1) {
      total += bomItem[storeAmountColumn[i]];
    }
    return total;
  }

  return {
    list,
    subJobType,
    statusClassMap,

    subJobStatus,
    subJobStatusTH,
    translateSubJobStatus,

    getProcessStatusColor,
    processStatusClassMap,
    processTranslate,

    assemblyAmountColumn,
    assemblyStatusClassMap,
    translateAssemblyStatus,
    statusToAssemblyAmountColumn,

    qcStatusEN,
    qcStatusTH,
    qcStatusAmountColumn,
    qcStatusClassMap,
    translateQCStatus,
    statusToQCAmountColumn,

    sumSubJobStatusAmount,
    subJobFilter,
  };
}
